'use client';

import { motion } from 'framer-motion';
import { listItemVariants, staggerContainerVariants } from '@/lib/animations';
import type { Service } from '@/services/ProductMiceDataService';

export interface ProductMiceServiceFeaturesProps {
    items: Service[];
}

/**
 * MICE detay: services_repeater verisi için kart grid (tur listesinden ayrı, daha güçlü görsel hiyerarşi).
 */
export default function ProductMiceServiceFeatures({ items }: ProductMiceServiceFeaturesProps) {
    const filtered = items.filter((service) => {
        if (!service || typeof service !== 'object') return false;
        const title = service.title || service.name || service.value || service.text || '';
        return typeof title === 'string' && title.trim().length > 0;
    });

    if (filtered.length === 0) return null;

    return (
        <motion.ul
            className="m-0 grid list-none grid-cols-1 gap-5 p-0 sm:grid-cols-2 md:gap-6 lg:gap-7"
            role="list"
            variants={staggerContainerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '0px 0px -80px 0px' }}
        >
            {filtered.map((service, index) => {
                const title = String(service.title || service.name || service.value || service.text || '').trim();
                const description = String(
                    service.description || service.desc || service.detail || ''
                ).trim();

                return (
                    <motion.li key={index} className="group" variants={listItemVariants}>
                        <article className="h-full rounded-xl border border-gray-200/90 bg-gradient-to-br from-white to-gray-50/90 p-5 shadow-[0_1px_4px_rgba(15,23,42,0.06)] transition-all duration-200 hover:border-alsero-first/30 hover:shadow-md">
                            <div className="flex items-start gap-4">
                                <div
                                    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-alsero-first/10 text-sm font-bold text-alsero-first ring-2 ring-alsero-first/5"
                                    aria-hidden
                                >
                                    {index + 1}
                                </div>
                                <div className="min-w-0 flex-1 space-y-2">
                                    <h3 className="text-base font-semibold leading-snug text-alsero-dark-gray">
                                        {title}
                                    </h3>
                                    {description ? (
                                        <p className="text-sm leading-relaxed text-alsero-text-tour">{description}</p>
                                    ) : null}
                                </div>
                            </div>
                        </article>
                    </motion.li>
                );
            })}
        </motion.ul>
    );
}
